/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { globalSearchGetVaultList } from '../fn/global-search/global-search-get-vault-list';
import { GlobalSearchGetVaultList$Params } from '../fn/global-search/global-search-get-vault-list';
import { GlobalSearchVaultList } from '../models/global-search-vault-list';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `globalSearchGetVaultList()` */
  static readonly GlobalSearchGetVaultListPath = '/global-search/vault/list';

  /**
   * Get vaults with any found documents.
   *
   * Get vaults with any found documents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalSearchGetVaultList()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSearchGetVaultList$Response(params: GlobalSearchGetVaultList$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalSearchVaultList>> {
    const obs = globalSearchGetVaultList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get vaults with any found documents.
   *
   * Get vaults with any found documents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalSearchGetVaultList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalSearchGetVaultList(params: GlobalSearchGetVaultList$Params, context?: HttpContext): Observable<GlobalSearchVaultList> {
    const resp = this.globalSearchGetVaultList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GlobalSearchVaultList>): GlobalSearchVaultList => r.body)
    );
  }

}
